import { IconButton } from '@shared/ui/Actions/IconButton'
import IconSearch from '@icons/icon-search.svg'
import React, { FC, useCallback, useEffect, useState } from 'react'
import { Modal } from '@shared/ui/Overlays/Modal'
import { Search } from '@shared/ui/Form/Build/Search'
import { getDefaultField } from '@shared/lib/fields/getDefaultField'
import { EGG } from '@shared/api/analytics'
import { useQuickSearch } from '@features/QuickSearch/useQuickSearch'
import { useRouter } from 'next/navigation'
import s from './QuickSearchButton.module.sass'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { ModalView } from '@shared/ui/Overlays/ModalView/ModalView'
import {
  QuickSearchOutputEmpty,
  QuickSearchOutputList,
  QuickSearchOutputListSkeleton,
} from '@features/QuickSearch/ui/QuickSearchOutput'

const DEFAULT_FIELD = getDefaultField('search', {
  settings: {
    placeholder: '',
  },
})

export const QuickSearchButton: FC = () => {
  const router = useRouter()
  const { isMobile } = useClientResponsive()

  const [isOpenedPopup, setIsOpenedPopup] = useState(false)
  const [input, setInput] = useState(DEFAULT_FIELD)

  const [searchResults, isLoading, { tryQuickSearch, isError }] = useQuickSearch()

  const handleCloseIcon = useCallback(() => {
    EGG.quickSearch.close_click()
    handleCloseModal()
  }, [])

  const handleCloseModal = () => {
    setIsOpenedPopup(false)
    setInput(DEFAULT_FIELD)
  }

  const isDataEmpty = searchResults.length === 0 && !isLoading
  const isDataAvailable = searchResults.length !== 0 && !isLoading

  useEffect(() => {
    EGG.quickSearch.text_type()
  }, [])

  const SearchOutput = () => {
    if (isError) return <QuickSearchOutputEmpty mode={'error'} />
    if (isLoading) return <QuickSearchOutputListSkeleton />
    if (isDataEmpty) return <QuickSearchOutputEmpty mode={isMobile ? 'empty-picture' : 'empty-text'} />
    if (isDataAvailable)
      return (
        <QuickSearchOutputList
          list={searchResults}
          onClickItem={handleCloseModal}
          onClickAllResults={handleClickAllResults}
        />
      )
    return <></>
  }

  const handleClickAllResults = () => {
    router.push(`https://www.afisha.ru/search/restaurant/?query=${input.value}`)
    handleCloseModal()
  }

  const Filler = (
    <>
      <Search
        field={input}
        setField={setInput}
        handleChange={tryQuickSearch}
        className={s['search-input']}
        autoFocus={true}
      />
      {input?.value && (
        <div className={s['quick-search-output']}>
          <SearchOutput />
        </div>
      )}
    </>
  )

  return (
    <>
      {isOpenedPopup &&
        (isMobile ? (
          <Modal size='XL' className={s.container} title='Найти на афише' handleClose={handleCloseIcon}>
            {Filler}
          </Modal>
        ) : (
          <ModalView className={s['align-start']} handleClose={handleCloseIcon} buttonClose={!isMobile}>
            <div className={s['desk-container']}>{Filler}</div>
          </ModalView>
        ))}

      <IconButton
        data-icon={'IconSearch'}
        icon={IconSearch}
        sizes='L M'
        mode='white-border'
        onClick={() => {
          EGG.header.button_search_click()
          setIsOpenedPopup(true)
          EGG.quickSearch.page_shown()
        }}
      />
    </>
  )
}
